import { Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { ReactComponent as ErrorAlertIcon } from '../../../../../../assets/icons/layout-icons/ErrorAlertIcon.svg';
import { ReactComponent as CancelIcon } from '../../../../../../assets/icons/project-icons/CancelCircleIcon.svg';
import { ReactComponent as TrashIcon } from '../../../../../../assets/icons/layout-icons/TrashIcon.svg';
import ConfirmModal from '../../../../../../components/confirm-modal/ConfirmModal';
import { primaryLight, secondaryBlue, secondaryPink } from '../../../../../../utils/color';
import { useTranslation } from 'react-i18next';

interface DeleteTaskFileModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  type: 'delete' | 'error';
  onConfirm?: () => void;
  isLoading?: boolean;
}

const DeleteTaskFileModal = ({
  isOpen,
  setIsOpen,
  type,
  onConfirm,
  isLoading,
}: DeleteTaskFileModalProps) => {
  const { t } = useTranslation();

  const modalsContent = {
    delete: {
      title: t('common.deleteFile'),
      text: t('common.deleteFileConfirm'),
      icon: <TrashIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
      wrapperBackgroundColor: primaryLight[100],
    },
    error: {
      title: t('errors.error'),
      text: t('errors.somethingWentWrong'),
      icon: <ErrorAlertIcon fill={secondaryPink[700]} style={{ width: 24, height: 24 }} />,
      wrapperBackgroundColor: secondaryPink[100],
    },
  };

  return (
    <ConfirmModal
      automaticallyCloseModalOnButtonClick={false}
      isLoading={isLoading}
      width="50%"
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title={modalsContent[type].title}
      message={
        <Typography color="primaryDark.500" lineHeight="21px">
          {modalsContent[type].text}
        </Typography>
      }
      confirmButtonText={type === 'delete' ? t('common.delete') : t('common.close')}
      onConfirm={onConfirm}
      iconProps={{
        icon: modalsContent[type].icon,
        wrapperBackgroundColor: modalsContent[type].wrapperBackgroundColor,
      }}
      showCancelButton={type === 'delete' && !isLoading}
      onCancel={() => setIsOpen(false)}
    />
  );
};

export default DeleteTaskFileModal;
